import axios from 'axios';

import { adminPatientsFail, adminPatientsRequest, adminPatientsSuccess, patientsCatageoryFail, patientsCatageoryRequest, patientsCatageorySuccess, patientsFail, patientsRequest, patientsSuccess } from '../slices/patientsSlice';
import { deletePatientFail, deletePatientFileFail, deletePatientFileRequest, deletePatientFileSuccess, deletePatientRequest, deletePatientSuccess, newPatientFail, newPatientRequest, newPatientSuccess, patientFail, patientRequest, patientSuccess, updateMedicalFail, updateMedicalRequest, updateMedicalSuccess, updatePatientFail, updatePatientRequest, updatePatientSuccess } from '../slices/patientSlice';


export const getpatients = (keyword,catageory,ratings,currentPage) => async (dispatch) => {
    try{

        dispatch(patientsRequest());
        let link = `/api/v1/patients?page=${currentPage}`
        if(keyword){
            link += `&keyword=${keyword}`

        }
        if(catageory){
            link += `&category=${catageory}`
        }
        if(ratings){
            link += `&ratings=${ratings}`
        }
        const { data } = await axios.get(link)
        dispatch(patientsSuccess(data));


    }catch(error){
        dispatch(patientsFail(error.response.data.message))
    }
}

export const getcategory = catageory => async (dispatch) => {
    try{

        dispatch(patientsCatageoryRequest());
        const { data } = await axios.get(`/api/v1/category?category=${catageory}`)
        dispatch(patientsCatageorySuccess(data));


    }catch(error){
        dispatch(patientsCatageoryFail(error.response.data.message))
    }
}

export const getpatient = id => async (dispatch) => {
    try{

        dispatch(patientRequest());
        const { data } = await axios.get(`/api/v1/patient/${id}`)
        dispatch(patientSuccess(data));


    }catch(error){
        dispatch(patientFail(error.response.data.message))
    }
}

// plain (non-thunk) lookup used by the New Bill form to autofill patient
// details from their human-readable patient ID (e.g. GN-0005)
export const lookupPatientByPatientId = async (patientId) => {
    const { data } = await axios.get(`/api/v1/patient/lookup/${patientId}`);
    return data.patient;
}


// export const createReview = reviewData => async (dispatch) => {

//     try {  
//         dispatch(createReviewRequest()) 
//         const config = {
//             headers : {
//                 'Content-type': 'application/json'
//             }
//         }
//         const { data }  =  await axios.put(`/api/v1/review`,reviewData, config);
//         dispatch(createReviewSuccess(data))
//     } catch (error) {
//         //handle error
//         dispatch(createReviewFail(error.response.data.message))
//     }
    
// }


// export const getAdminPatients  =  async (dispatch) => {

//     try {  
//         dispatch(adminPatientsRequest()) 
//         const { data }  =  await axios.get(`/api/v1/admin/patient`);
//         console.log(data)
//         dispatch(adminPatientsSuccess(data))
//     } catch (error) {
//         //handle error
//         dispatch(adminPatientsFail(error.response.data.message))
//     }
    
// }
export const getAdminPatients = (maybeDispatch) => {
  const thunk = async (dispatch) => {
    try {
      dispatch(adminPatientsRequest());
      const { data } = await axios.get(`/api/v1/admin/patient`);
      dispatch(adminPatientsSuccess(data));
    } catch (error) {
      dispatch(
        adminPatientsFail(
          error.response?.data?.message || error.message
        )
      );
    }
  };

  if (typeof maybeDispatch === 'function') {
    return thunk(maybeDispatch);
  }
  return thunk;
};

export const createNewPatient  =  patientData => async (dispatch) => {

    try {  
        dispatch(newPatientRequest()) 
        const { data }  =  await axios.post(`/api/v1/admin/patient/new`, patientData);
        dispatch(newPatientSuccess(data))
    } catch (error) {
        //handle error
        dispatch(newPatientFail(error.response.data.message))
    }
    
}


export const deletePatient  =  id => async (dispatch) => {

    try {  
        dispatch(deletePatientRequest()) 
        await axios.delete(`/api/v1/admin/patient/${id}`);
        dispatch(deletePatientSuccess())
    } catch (error) {
        //handle error
        dispatch(deletePatientFail(error.response.data.message))
    }
    
}

export const deletePatientFile = (id, data) => async (dispatch) => {

    try {
        dispatch(deletePatientFileRequest());

        await axios.delete(`/api/v1/admin/patient/${id}/file`, {
            data
        });

        dispatch(deletePatientFileSuccess());

    } catch (error) {
        dispatch(deletePatientFileFail(error.response.data.message));
    }
};


export const updatePatient  =  (id, productData) => async (dispatch) => {

    try {  
        dispatch(updatePatientRequest()) 
        const { data }  =  await axios.put(`/api/v1/admin/patient/${id}`, productData);
        dispatch(updatePatientSuccess(data))
    } catch (error) {
        //handle error
        dispatch(updatePatientFail(error.response.data.message))
    }
    
}

export const updatePatientMedical = (id, medicalData) => async (dispatch) => {
    try {
        dispatch(updateMedicalRequest());

        const { data } = await axios.put(
            `/api/v1/patient/${id}/medical`,
            medicalData
        );

        dispatch(updateMedicalSuccess(data));

    } catch (error) {
        dispatch(updateMedicalFail(error.response.data.message));
    }
};


// export const getReviews =  id => async (dispatch) => {

//     try {  
//         dispatch(reviewsRequest()) 
//         const { data }  =  await axios.get(`/api/v1/admin/reviews`,{params: {id}});
//         dispatch(reviewsSuccess(data))
//     } catch (error) {
//         //handle error
//         dispatch(reviewsFail(error.response.data.message))
//     }
    
// }

// export const deleteReview =  (productId, id) => async (dispatch) => {

//     try {  
//         dispatch(deleteReviewRequest()) 
//         await axios.delete(`/api/v1/admin/review`,{params: {productId, id}});
//         dispatch(deleteReviewSuccess())
//     } catch (error) {
//         //handle error
//         dispatch(deleteReviewFail(error.response.data.message))
//     }
// }